import { Pipe, PipeTransform } from '@angular/core';

import { ApplicationService } from '../services/application/application.service';

@Pipe({
    name: 'AcceleratedDegreeProgram'
})
export class AcceleratedDegreeProgramPipe implements PipeTransform {
    constructor(private appService : ApplicationService) { }

    transform(programID: number) {
        if (programID == null) return '';
        if (!this.appService._AcceleratedPrograms || !this.appService._AcceleratedPrograms.length) return '';

        let program = this.appService._AcceleratedPrograms.find(item => {
            return item.AcceleratedDegreeProgramID == programID;
        });

        return (program && program.Name) || programID;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/accelerateddegreeprogram.pipe.ts